import useAct from '../useAct';
import _ from 'lodash';
import { ClientEditableConfigTranslatableKeys, clientEditableConfigTranslatables } from '../lib/clientEditableConfigTranslatable';
import useTranslatable from "Shared/TranslatableTextContent/hooks/useTranslatable";
import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData';

export default function useBrandSettingsTranslate<T extends string | number | symbol = ClientEditableConfigTranslatableKeys>({ brandOverride = null, languageOverride = null } = {}) {
  const act = useAct();

  const clientLanguages = clientLanguagesData()

  const brand = useSel((s) => brandOverride || s.brand)
  const textContent = brand?.textContent || {}

  const language: string = useSel(s => languageOverride || s.local?.language || null)
  const languagePrefix = language || 'en'
  const defaultLanguage = 'en'

  const translated = useTranslatable<T>({
    textContent,
    useFallback: true,
    language: languagePrefix,
    translatableConfiguration: clientEditableConfigTranslatables,
    defaultLanguage
  })
  const fallback = useTranslatable<T>({
    textContent,
    useFallback: true,
    language: languagePrefix,
    translatableConfiguration: clientEditableConfigTranslatables,
    defaultLanguage
  })

  const flag = Object.keys(clientLanguages).length > 1 ? clientLanguages[language]?.flag || '' : ''
  
  function textContentUpdater(key: T, value: string) {
    act.brand.updateBrandTextContent({ language, key, value })
  }
  
  return {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag
  }
}
